/**
 * English translation strings.
 *
 * @module assets.lang.en
 */

export const name = 'English';

/**
 * Export the localized strings used throughout the app.
 * No particular logic is used to order and cateogorize those strings, just
 * put them wherever feels right.
 *
 * @exports
 */
export const messages = {
  meta: {
    subtitle: 'Diabetes correlation engine',
  },
  home: {
    title: 'Flexible diabetes correlation engine.',
    subtitle: 'Sugar Nanny is a free, open-source web application that helps you correlate your blood sugar results with mutliple external factors &mdash; without your health data ever leaving your browser.',
    about: {
      title: 'About Sugar Nanny',
      text: 'Sugar Nanny allows you to load up your <b>Freestyle Libre</b>, <b>Google Location History</b>, <b>MyFitnessPal</b> and <b>Google Calendar</b> data, as well as data from various external sources (weather, pollution, ...), to correlate and visualize everything clearly, thus helping you better manage your diabetes and living a healthy, more fulfilling life.<br/><br/>Sugar Nanny is entirely free and open-source, and guarantees that your personnal health data is neither sent over the Internet nor stored anywhere other than your own computer.',
    },
    news: {
      title: 'Don\'t miss any news.',
      text: 'Subscribe to our newsletter and get informed when new features or data sources are added.<br/>We don\'t use emails for anything else, and we won\'t sell them. Ever.',
      mail: 'Email address',
    },
    mail: {
      subscribed: {
        title: 'Subscribed!',
        text: 'You have been successfully subscribed to our newsletter. Thanks!',
      },
    },
  },
  footer: {
    copy: 'Copyright © {year} &mdash; All rights reserved',
    about: 'About us',
    technical: 'Tech talk',
    contact: 'Keeping in touch',
    aboutLink: {
      concept: 'Concept',
      how: 'How it works',
      legal: 'Terms of service',
      help: 'Product help',
    },
    contactLink: {
      team: 'The team',
      contact: 'Contact',
      social: 'Social media',
    },
    technicalLink: {
      sitemap: 'Site map',
      contribute: 'How to contribute',
      report: 'Report an issue',
      source: 'Source code',
    },
  },
  start: {
    meta: {
      title: 'Start the engine',
    },
    new: 'I want to start anew',
    code: 'I want to load a previous session',
    codeMore: 'The session dump file will be asked.',
  },
  startBloodSugar: {
    meta: {
      title: 'Load blood sugar data',
    },
    title: 'Load blood sugar data.',
    subtitle: 'Please upload your <b>FreeStyle Libre</b> exported <em>.csv</em> file.',
    next: 'MyFitnessPal reports',
  },
  startMeals: {
    meta: {
      title: 'Connect to MyFitnessPal',
    },
    title: 'Load MyFitnessPal reports data.',
    subtitle: 'Please enter your <b>MyFitnessPal</b> username.<br/>Your food diary must be public.',
    next: 'Google Location History data',
    username: 'MyFitnessPal username',
  },
  startLocation: {
    meta: {
      title: 'Load location history data',
    },
    title: 'Load location history data.',
    subtitle: 'Please upload your <b>Google Takeout Location History</b> exported <em>.json</em> file.',
    next: 'Google Calendar events',
  },
  startCalendar: {
    meta: {
      title: 'Connect to Google Calendar',
    },
    title: 'Load Google Calendar events data.',
    subtitle: 'Please authorize Sugar Nanny to access one of your <b>Google Calendar</b> calendars.',
    next: 'All done and ready to go!',
    almost: 'We\'re almost there!',
    authorize: 'Connect to Google Calendar',
    events: '{n} events in calendar.',
  },
  startCode: {
    meta: {
      title: 'Load a previous session',
    },
    title: 'Load a previous session.',
    subtitle: 'Please upload the previously exported session dump file.',
    id: 'Session identifier',
    passKey: 'Unlock passphrase',
  },
  dashboard: {
    meta: {
      title: 'Dashboard',
    },
    download: 'Download session file',
    title: 'Dashboard',
    subtitle: 'Visualize your data.',
    events: {
      title: 'Your events',
      nothing: 'There are no events in the specified date range.',
    },
    data: {
      title: 'Associated data',
      nothing: 'There\'s no data yet. Select an event to display more intel about it.',
      meal: {
        title: 'Day food intake',
      },
      position: {
        title: 'Location',
      },
      meteo: {
        title: 'Day weather report',
      },
      pollution: {
        title: 'Day pollution report',
      },
    },
  },
  controls: {
    start: 'Get Started',
    back: 'Go back',
    next: 'Next',
    subscribe: 'Subscribe',
    step: 'Step',
    upload: 'Select file',
    loadDrive: 'Load from Drive',
    or: 'or',
    skip: 'Skip',
    parsing: 'Crunching data',
  },
};



// WEBPACK FOOTER //
// ./src/assets/lang/en.js